var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsWithBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H24C32.8366 0 40 7.16344 40 16V24C40 32.8366 32.8366 40 24 40H16C7.16344 40 0 32.8366 0 24V16Z",
    fill: "#F2F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1258 20.0088C9.22917 18.5864 10.6516 17.1639 10.6516 17.1639L14.8039 13.0116C15.9149 11.9006 17.7162 11.9006 18.8272 13.0116L19.8975 14.082M19.8975 14.082C19.8975 14.082 20.2372 14.4217 22.0312 16.2156C23.8251 18.0096 21.557 20.0088 19.6604 18.1122C18.7631 17.2149 18.2903 16.7421 18.0412 16.493C17.8634 16.3152 17.6639 16.3155 17.4861 16.4934L12.5482 21.4313C12.5482 21.4313 12.0741 23.3279 14.4448 23.3279C14.4448 25.6986 16.3414 25.2245 16.3414 25.2245C16.3414 25.2245 16.3414 27.5952 18.238 27.1211C18.238 28.5435 19.6604 30.4401 21.557 28.5435C22.8263 27.2742 26.6441 23.4565 29.0306 21.0699C30.1416 19.9589 30.1394 18.1599 29.0284 17.0489L24.9911 13.0116C23.8801 11.9006 22.0788 11.9006 20.9678 13.0116L19.8975 14.082Z",
    stroke: "#525355",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsWithBg);
export default __webpack_public_path__ + "static/media/clientsWithBg.ecd23c164c6df336daf06ece8de0b251.svg";
export { ForwardRef as ReactComponent };